<template>
  <div>
    <v-container v-if="logoUrl">
      <v-row >
        <v-col class="py-8">
          <v-img height="72px" contain :src="logoUrl"></v-img>
        </v-col>
      </v-row>
    </v-container>
    <CarContainer :cars="this.cars" />
  </div>
</template>


<script>
import {
  getFirestore,
  getDocs,
  query,
  where,
  collection,
} from "firebase/firestore/lite";

import CarContainer from "../components/CarContainer.vue";

export default {
  components: { CarContainer },

  data() {
    return {
      brandName: this.$route.params.brandname,
      cars: null
    };
  },

  computed: {
    logoUrl() {
      return this.$store.state.brands?.[this.brandName]?.logoUrl
    }
  },

  mounted() {
    this.getCars();
  },

  methods: {
    async getCars() {
      const ref = collection(getFirestore(), 'cars')
      const q = query(ref, where('brandLogicalName', '==', this.brandName));
      this.cars = (await getDocs(q)).docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
    }
  },
};
</script>